var map = {
	"./Bank_LOGO.png": 6167,
	"./CreditCard.webp": 7767,
	"./DebitCardIssue.png": 54,
	"./DebitCardReject.png": 7838,
	"./FDCard.webp": 3104,
	"./Forgot Password.png": 3399,
	"./Login_BG.png": 6680,
	"./Login_Page_Image.png": 1362,
	"./Reject.png": 5962,
	"./RejectDebitCard.png": 772,
	"./RejectNotification.png": 6487,
	"./ReqToImprove.png": 7046,
	"./SDB_LOGO.png": 886,
	"./Success.png": 202,
	"./all_sms_icon.png": 6398,
	"./application_icon.png": 8973,
	"./approved_icon.png": 6456,
	"./default-image.png": 4972,
	"./improved_icon.png": 5439,
	"./issued_cards_icon.png": 5042,
	"./notification-icon1.png": 3817,
	"./notification-icon2.png": 5634,
	"./notification-icon3.png": 827,
	"./notificationIcon.png": 7305,
	"./notify-bell1.png": 2895,
	"./notify-bell2.png": 9684,
	"./pdfLogo.png": 864,
	"./pdfLogo1.png": 155,
	"./pending_for_review_icon.png": 739,
	"./pending_icon.png": 8564,
	"./rejected_icon.png": 4881,
	"./reqto_improve_icon.png": 1649,
	"./sms_active_icon.png": 4651,
	"./sms_failed_icon.png": 3824
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;